<template>
    <div class="storage-allocation">
        <compWrapper theme="primary" title="出库预测报表导出">
            <vForm class="margin-layout" labelWidth="100" v-model="formData" ref="editform">
            <vCol span="10">
              <vFormItem label="入库计划单号" prop="inboundNo" :rules="required">
                <vInput v-model="formData.inboundNo" clearable></vInput>
              </vFormItem>
            </vCol>
            </vForm>
            <vButtonGroup>
                <vButton  class="margin-left-20" theme="info" @click="submit">导出</vButton>
			</vButtonGroup>
        </compWrapper>
    </div>
</template>

<script>
import {HttpOutboundForecast  } from '@/service/storageallocation';
 export default {

    data() {
        return {
            loading: false,
            formData: {
             
            },
            required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ]
        };
    },
    methods: {
        async submit(){
            const valid = await this.$refs.editform.validate();
            if(!valid) {return}
           HttpOutboundForecast({
                ...this.formData
            }).then(
                (res) => {
                   this.handleWebfs(
                      process.env.VUE_APP_APIURL_FBB + "/api/v2/outboundForecast/export", { ...this.formData },
                      "download"
                    );
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        }
    }
}
   
</script>
